module.exports = __webpack_public_path__ + "static/media/3H.dfb7b9c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3H.svg
// module id = 59
// module chunks = 0